import { render, staticRenderFns } from "./ContestNotification.vue?vue&type=template&id=6e41fb2a&scoped=true"
import script from "./ContestNotification.vue?vue&type=script&lang=ts"
export * from "./ContestNotification.vue?vue&type=script&lang=ts"
import style0 from "./ContestNotification.vue?vue&type=style&index=0&id=6e41fb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e41fb2a",
  null
  
)

export default component.exports